import { render } from "./CreateRequest.vue?vue&type=template&id=a6645050&scoped=true"
import script from "./CreateRequest.vue?vue&type=script&lang=js"
export * from "./CreateRequest.vue?vue&type=script&lang=js"

import "./CreateRequest.vue?vue&type=style&index=0&id=a6645050&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6645050"]])

export default __exports__